<template>
  <div class="">

    <table class="table text-center table-striped">
      <thead>
      <tr>
        <th scope="col">نام درس</th>
        <th scope="col">#</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(lesson,index) in lessons">
        <td>{{ lesson.title }}</td>
        <td>
          <button class="btn btn-primary rounded-pill" v-for="course in lesson.courses" :key="course.id">
            <router-link v-for="product in course.products" :key="product.id" :to="{name:'PrintCourseForm',params:{form:form.id,product:product.id}}">
              <button class="btn btn-primary rounded-pill">{{product.name}} - {{ course.title }}</button>
            </router-link>
          </button>
        </td>
      </tr>

      </tbody>
    </table>


    <b-row class="pt-3 mt-3">
      <pagination :meta="pagination" :on-change-page="changePage"/>
    </b-row>

  </div>
</template>

<script>
import Pagination from "../Pagination.vue";

export default {
  name: "FormLessons",
  components: {Pagination},
  props: {
    form: {}
  },
  data() {
    return {
      lessons: [],
      pagination: {}
    }
  },
  methods: {
    async loadLessons(page) {
      let form = {
        id: this.form.id,
        page: page
      }
      let req = await this.$store.dispatch('Form/formLessons', form)
      let data = req.data.data
      this.pagination = data.meta
      this.lessons = data.data
    },
    changePage(page) {
      this.loadLessons(page)
    },
  },
  mounted() {
    this.loadLessons()
  }
}
</script>

<style scoped>

</style>